<template>
  <modal name="popup-banner-create-modal" class="popup-banner-modal"
         :width="'500px'"
         :height="'auto'"
         @before-close="handlerBeforeClose"
         @before-open="handlerBeforeOpen"
         @opened="handlerOpened"
  >
    <div class="list-content pa15">
      <div class="modal_title border-bottom">팝업 등록</div>
      <div class="pl30 pr30 pb15">
          <banner-write-component :banner-type="'popupCreate'"></banner-write-component>
        <div class="btn_wrap text-center mt20">
          <el-button type="save" @click="save">저장</el-button>
          <el-button type="cancel" @click="close()">닫기</el-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>

import util from "@/mixins/util";
import BannerWriteComponent from "@/components/banner/BannerWriteComponent";

import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";

export default {
  name: "PopupBannerCreateModal",
  mixins: [alertMixins],
  components: {
      BannerWriteComponent
  },
  props: {
  },
  data() {
    return {
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    handlerBeforeOpen(event) {
    },
    handlerOpened() {
    },
    handlerBeforeClose() {
    },
    close(){
      this.$modal.hide('popup-banner-create-modal');
    },
    afterFunc(){
      this.createAlert({
        content: '저장되었습니다.',
        hide: () => {
          this.$modal.hide('popup-banner-create-modal');
        }
      })
    },
    save(){
      EventBus.$emit('writeBanner')
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
